import SourceVector from '../node_modules/ol/source/Vector.js'
import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js'
import FormatTopoJSON from '../node_modules/ol/format/TopoJSON.js'

/**
 * @constructor
 * @param {object} params - May be empty or an object: {
 *      'url': string - req'd if params are provided
 *      'data': object - optional ajax payload (fetch body)
 *      'loaded': function - optional callback
 *      'properties': object - optional properties assigned to the new source
 *    }
 *    if a params object is supplied the new data source gets an ajax loader function
 * @return {object}  A new OpenLayers vector data source from either TopoJSON
 *    or GeoJSON data or if no params are supplied, an empty vector source.
 * If a data source url is provided the the data is loaded into the returned ol source.
 * If the data source has a "style_" field the sytle will be applied to each feature where "style_" is not null.
 */

export default function (params) {
  this.srcParams // ol vector data source params: https://openlayers.org/en/latest/apidoc/module-ol_source_Vector.html
  if (params) {
    // could improve this by having the default options below as a template and
    // then allowing params to overwrite whatever it has rather than
    // reading params.url and params.data individually
    this.srcParams = {
      loader: function (extent, resolution, projection) { // must use "function" here not "=>" to get access to "this"
        // eslint-disable-line no-unused-vars
        let self = this;

        /*
          Uncaught (in promise) TypeError: Failed to execute 'fetch' on 'Window': Request with GET/HEAD method cannot have body.

          Need to see if a data element has been provided in addition to, or instead of, checking GET vs POST
          Only Laramie appears to specify "params.method"
        */

        // If there's params.data make it a POST request and add a "body"
        let options = null
        if (params.data) {
          let payload = params.data
          payload.extent = extent
          payload.resolution = resolution
          payload.epsg = projection.getCode()
          options = {
            method: 'POST', // S3 doesn't support POST requests
            contentType: 'application/json', // This may cause a preflight OPTIONS request which causes CORS error
            body: JSON.stringify(payload),
          }
        }

        fetch(params.url, options)
          .then(response => response.json())
          .then(responseJSON => {
            let type = responseJSON.type
            let format
            if (type === 'Topology') {
              let layers = [];
              // below might produce undesireable results if more than one layer in 'objects"
              for (let obj in responseJSON.objects) {
                layers.push(obj)
              }
              format = new FormatTopoJSON({
                // defaultDataProjection: 'EPSG:3739', // IMPORTANT! https://github.com/openlayers/openlayers/issues/4264
                layers: layers,  // in the topojson this is the "objects" key
              })
            } else if (type === 'FeatureCollection') {
              format = new FormatGeoJSON();
            }
            let features = format.readFeatures(responseJSON);
            self.addFeatures(features);
            // apply the saved style if there is one
            features.forEach((feature) => {
              let style = feature.get('style_');
              if (style) {
                feature.setStyle( [ rwg.styles.makeStyle(JSON.parse(style)) ] )
              }
            })
            params?.loaded?.(self) // callback defined in config.js
          })
      },
      // strategy: bbox, // all | bbox | tile
      // projection: rwg.cs.data,
      projection: rwg.proj.dataSRID,
    }
    // console.log('SourceJSON', params)
  }

  this.vectorSource = new SourceVector(this.srcParams)
  // 2022-07-31 the only project where RWG found properties in use is tcwp
  // check: rwg.sources.list.sites.get('attributes')
  if (params?.properties) {
    this.vectorSource.setProperties(params.properties)
  }

  return this.vectorSource
}
